import _get from "lodash/get";
import styled from 'styled-components';
import { rem, lighten } from 'polished';
import modalTheme from '../../../styles/modalTheme';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "jk5j4h-0"
})(["background-color:", ";border-top-color:", ";border-top-style:solid;border-top-width:1px;padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return lighten(0.1, _get(theme, 'modal.footer.backgroundColor', modalTheme.modal.footer.backgroundColor));
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'modal.footer.dividerColor', modalTheme.modal.footer.dividerColor);
}, rem(16));
export default Container;